import { TabSelect } from '@components';
import adminPortalContent from '@containers/Home/constants/AdminPortalContent';
import { ContainerLayout } from '@layouts';
import Image from 'next/image';
import styles from './styles.module.scss';

export const AdminPortal = () => (
  <ContainerLayout
    outerContainerClassName={styles.outerContainer}
    innerContainerClassName={styles.innerContainer}
  >
    <div className={styles.contentContainer}>
      <div className={styles.headerText}>
        <h1>Toolkit & Dashboard</h1>
        <span>
          Manage your staff engagement in one single portal. Our admin portal provides the simplest
          way to self-manage content, view real time data and generate reports.
        </span>
      </div>
      <div className={styles.primaryContent}>
        <div className={styles.featureImage}>
          <Image src={adminPortalContent[0].image} alt="" fill />
        </div>
        <div className={styles.featureContainer}>
          {Object.values(adminPortalContent).map(({ title: main }) => (
            <TabSelect key={main} onClick={() => null} title={main} isSelected />
          ))}
        </div>
      </div>
    </div>
  </ContainerLayout>
);

AdminPortal.displayName = 'AdminPortal';

export default AdminPortal;
